export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const DASHBOARD_SCAN_REQUEST = "DASHBOARD_SCAN_REQUEST";
export const DASHBOARD_SCAN_SUCCESS = "DASHBOARD_SCAN_SUCCESS";
export const DASHBOARD_SCAN_FAIL = "DASHBOARD_SCAN_FAIL";
export const DASHBOARD_RESET = "DASHBOARD_RESET";

export const FORGET_REQUEST = "FORGET_REQUEST";
export const FORGET_SUCCESS = "FORGET_SUCCESS";
export const FORGET_FAIL = "FORGET_FAIL";

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';

export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAIL = 'VERIFY_OTP_FAIL';

export const RESEND_OTP_REQUEST = 'RESEND_OTP_REQUEST';
export const RESEND_OTP_SUCCESS = 'RESEND_OTP_SUCCESS';
export const RESEND_OTP_FAIL = 'RESEND_OTP_FAIL';

export const OTP_VERIFICATION_RESET = 'OTP_VERIFICATION_RESET';

export const CLEAR_ERRORS = 'CLEAR_ERRORS';
